import { ReturnRequestLineItemDto } from "@babackapp/private-api-client/types";

type ArticleItemRejectReasonProps = {
  lineItem: ReturnRequestLineItemDto;
};

export default function ArticleItemRejectReason({
  lineItem,
}: ArticleItemRejectReasonProps) {
  /**
   * Get the first rejected reason out
   * of merchant informations and logistician informations
   * to display it
   */
  const reason = [
    ...lineItem.merchant_informations,
    ...lineItem.logistician_informations,
  ].find((info) => info.status === "rejected")?.reason;

  return reason ?? "Empty reject reason";
}
